$(document).ready(function(){
$('.testimonialsWrap').slick({
dots: true,
infinite: true,
speed: 300,
slidesToShow: 3,
slidesToScroll: 2,
arrows: true,
autoplay: true,
autoplaySpeed: 5000,
responsive: [   
{
  breakpoint: 768,
  settings: {
    slidesToShow: 2,
    slidesToScroll: 2
  }
},
{
  breakpoint: 480,
  settings: {
    slidesToShow: 1,
    slidesToScroll: 1
  }
}
]
});
$('.CollListWrap').slick({
dots: false,
infinite: true,
speed: 300,
slidesToShow: 3,
slidesToScroll: 2,
arrows: true,
autoplay: true,
autoplaySpeed: 5000,
centerMode: true,
centerPadding: '15%',
responsive: [   
{
  breakpoint: 768,
  settings: {
    slidesToShow: 2,
    slidesToScroll: 1
  }
},
{
  breakpoint: 480,
  settings: {
    slidesToShow: 1,
    slidesToScroll: 1
  }
}
]
});


  $('.BrandWrapper').slick({
dots: false,
infinite: false,
speed: 300,
slidesToShow: 7,
slidesToScroll: 2,
arrows: false,
autoplay: false,
autoplaySpeed: 5000,
responsive: [   
{
  breakpoint: 768,
  settings: {
    slidesToShow: 4,
    slidesToScroll: 4,
    dots: true,
    arrows: false,
    autoplay: true,
    infinite: true,
  }
},
{
  breakpoint: 480,
  settings: {
    slidesToShow: 2,
    slidesToScroll: 2,
    dots: true,
    arrows: false,
    autoplay: true,
    infinite: true,
  }
}
]
});


   $('.phytoWrapper').slick({
dots: false,
infinite: false,
speed: 300,
slidesToShow: 5,
slidesToScroll: 2,
arrows: false,
autoplay: false,
autoplaySpeed: 5000,
responsive: [   
{
  breakpoint: 768,
  settings: {
    slidesToShow: 4,
    slidesToScroll: 4,
    dots: true,
    arrows: false,
    autoplay: true,
    infinite: true,
  }
},
{
  breakpoint: 480,
  settings: {
    slidesToShow: 2,
    slidesToScroll: 2,
    dots: true,
    arrows: false,
    autoplay: true,
    infinite: true,
  }
}
]
});



$('.sliderSteps').slick({
dots: false,
infinite: false,
speed: 300,
slidesToShow: 2,
slidesToScroll: 1,
arrows: true,
autoplay: false,
autoplaySpeed: 5000,
centerPadding: '3.5%',
responsive: [ 
{
  breakpoint: 767,
  settings: {
    slidesToShow: 1,
    slidesToScroll: 1,
    centerPadding: '15%',
  }
}
]
});


  
  
});
$(window).on('load',function(params) {
  setTimeout(function() {
     $('.stamped-reviews').slick('unslick');
  },500)
 
})

  $(document).ready(function() {
    
    $('#tab1').click(function(){
      $('#products').addClass('active');
      $('#rewards, #shipping, #returns').removeClass('active');
    });
    $('#tab2').click(function(){
      $('#rewards').addClass('active');
      $('#products, #shipping, #returns').removeClass('active');
    });
    $('#tab3').click(function(){
      $('#shipping').addClass('active');
      $('#products, #rewards, #returns').removeClass('active');
    });
    $('#tab4').click(function(){
      $('#returns').addClass('active');
      $('#products, #rewards, #shipping').removeClass('active');
    });
    
  });

  $(document).ready(function() {
  $(".set > a").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".content")
        .slideUp(200);
      $(".set > a i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
      $(".set > a i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      $(this)
        .find("i")
        .removeClass("fa-plus")
        .addClass("fa-minus");
      $(".set > a").removeClass("active");
      $(this).addClass("active");
      $(".content").slideUp(200);
      $(this)
        .siblings(".content")
        .slideDown(200);
    }
  });
});



	